
import { defineComponent, ref, reactive, toRefs, computed, watch, nextTick, watchEffect } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import f10Api from '@/api/f10Api'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      radiovalue: '',
      pagination: {},
      current: 1,
      data: [],
      columns: [],
      spinning: true,
      total: 0,
      radiolist: [],
      PageSize: 10
    })

    pageData.pagination = computed(() => {
      return {
        total: pageData.total,
        showSizeChanger: true,
        current: pageData.current,
        pageSize: pageData.PageSize,
        showTotal: (total: any) => `共${total}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        onChange: changesize,
        onShowSizeChange: changesize
      }
    })
    pageData.columns = [
      {
        title: '名次',
        dataIndex: 'Rank',
        key: 'Rank',
        width: '50px'
      },
      {
        title: '基金代码',
        dataIndex: 'FundCode',
        key: 'FundCode',
        width: '100px'
      },
      {
        title: '基金名称',
        dataIndex: 'FundName',
        key: 'FundName',
        width: '150px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '持股数(股)',
        dataIndex: 'HoldSum',
        key: 'HoldSum',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '持仓市值(元)',
        dataIndex: 'HoldMarketValue',
        key: 'HoldMarketValue',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '占总股本比例',
        dataIndex: 'CoverTotalSahareRatio',
        key: 'CoverTotalSahareRatio',
        width: '100px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '占总流通股本比例',
        dataIndex: 'CoverCirculateRtio',
        key: 'CoverCirculateRtio',
        width: '120px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '占净值比例',
        dataIndex: 'CoverNetRation',
        key: 'CoverNetRation',
        width: '90px',
        slots: { customRender: 'nocolorincrease' }
      }
    ]
    const route = useRoute()
    function getData(PageID: number, PageSize: number) {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code,
        // EndDate: new Date(pageData.radiovalue).getTime() / 1000,
        EndDate: pageData.radiovalue,
        PageID: PageID,
        PageSize: PageSize
      }
      data.headers = {
        token: props.token
      }
      f10Api.getholderfundhold(data).then((res: any) => {
        const data = JSON.parse(JSON.stringify(res.Data))
        if ((data.Detail || []).length) {
          data.Detail.forEach((item: any, i: number) => {
            item.index = 'FundHold' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
          })
        }
        pageData.total = data.Total
        pageData.data = data.Detail
      })
    }
    watchEffect(() => {
      const temp = pageData.radiovalue
      context.emit('getPubDate', temp)
    })
    function changeradio() {
      pageData.current = 1
      getData(pageData.current, pageData.PageSize)
    }
    function changesize(PageID: any, PageSize: any) {
      pageData.current = PageID
      pageData.PageSize = PageSize
      getData(PageID, PageSize)
      const dom: any = document.querySelector('.wrapper')
      const offsettop: any = document.getElementById('jjcg')?.offsetTop
      dom.scrollTop = offsettop
    }
    watch(
      () => (props.pageSourceData || {}).FundHold,
      (val: any) => {
        const data = JSON.parse(JSON.stringify(val))
        if ((data.DateList || []).length) {
          data.DateList.forEach((item: any) => {
            item.text = window.moment(item.EndDate * 1000).format('YYYY-MM-DD')
          })
          pageData.radiolist = data.DateList
          // (data.DateList || []).map((item: any) => window.moment(item.EndDate * 1000).format('YYYY-MM-DD'))
          pageData.radiovalue = pageData.radiolist[0].EndDate
          getData(1, pageData.PageSize)
        }
        nextTick(() => {
          pageData.spinning = false
        })
      },
      { deep: true }
    )
    return {
      ...toRefs(pageData),
      changeradio
    }
  }
})
